export enum EChatType {
  PRIVATE = 'user_user',
  OWN_COMPANY = 'own_company',
  CUSTOMER = 'user_company',
  COMPANY_COMPANY = 'company_company',
}

export enum EChatEventType {
  NEW_MESSAGE = 'NewMessage',
  LEAVE_CHANNEL = 'LeaveChannel',
  JOIN_CHANNEL = 'JoinChannel',
}

export enum EChatModals {
  ATTACHMENT = 'attachment',
}

export interface IChatParticipant {
  id: number;
  avatar_url: string;
  full_name: string;
  participant_id: number;
  last_read_message_id: string | null;
  last_read_message_at: number | null;
  is_leave: boolean;
}

export interface IChatMessageAttachment {
  id: number;
  mime_type: string;
  name: string;
  file_name: string;
  size: number;
  original_url: string;
  download_url: string;
  thumb_url?: string | null;
}

export interface IChatMessage {
  id: string;
  chat_id: string;
  sender_id: number;
  message: string;
  attachments: IChatMessageAttachment[];
  created_at: number;
}

export interface IChatUser {
  id: number;
  name: string;
}

export interface IChat {
  id: string;
  type: EChatType;
  name: string;
  image_url: string;
  participants: IChatParticipant[];
  last_message: IChatMessage | null;
  unread_count: number;
  target_id: number | null;
}

export interface FetchMessagesPayload {
  chat_id: string;
  limit: number;
  direction: 'newer' | 'older' | 'latest';
  reference_id?: string;
}

export interface IChatMessagesResponseMeta {
  meta: {
    has_more: boolean;
    last_read_message_id: string | null;
    unread_count: number;
  };
}

export interface SendMessagePayload {
  chat_id: string;
  message: string | null;
  'attachments[]'?: File[];
}

export interface MarkAsReadPayload {
  chat_id: string;
  last_read_message_id: string;
}

export interface CreateChatPayload {
  type: EChatType;
  target_id: number;
}

export interface ChatEventPayload {
  payload: {
    event: EChatEventType;
    message?: IChatMessage;
    chat?: IChat;
  };
}

export interface ChatEventTypingPayload {
  chatId: string;
  userId: number;
}

export interface ChatEventTrigger {
  type: EChatEventType;
  chat?: IChat;
  message?: IChatMessage;
}

export interface IChatModal {
  type: EChatModals;
  payload?: {
    attachment: IChatMessageAttachment;
    isImage: boolean;
  };
}
